(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wm-photo-wall"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    // Drag/swipe: offsets the animated track; wraps by half the track so the loop stays seamless
    document.addEventListener('pointerdown', (event) => {
      const viewport = event.target.closest('.wm-pw__viewport');
      if (!viewport || event.button > 0) return;
      const drag = viewport.querySelector('.wm-pw__drag');
      const half = viewport.querySelector('.wm-pw__track').scrollWidth / 2;
      const startX = event.clientX;
      const base = Number(drag.dataset.x) || 0;
      viewport.setPointerCapture(event.pointerId);
      viewport.classList.add('is-dragging');

      const move = (e) => {
        let x = (base + e.clientX - startX) % half;
        if (x > 0) x -= half;
        drag.dataset.x = x;
        drag.style.transform = `translateX(${x}px)`;
      };
      const end = () => {
        viewport.classList.remove('is-dragging');
        viewport.removeEventListener('pointermove', move);
        viewport.removeEventListener('pointerup', end);
        viewport.removeEventListener('pointercancel', end);
      };
      viewport.addEventListener('pointermove', move);
      viewport.addEventListener('pointerup', end);
      viewport.addEventListener('pointercancel', end);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
